module.exports = __webpack_public_path__ + "img/B8.41e2b304.svg";